import moment from 'moment';

import templateUrl from './rogers-tsu-report-container.component.html';

export const RogersTsuReportContainerComponent = {
    controller: TsuReportContainerController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        icdCorporationID: "<",
        isOwnerView: "<"
    }
};

function TsuReportContainerController($q, apexApiUrl, divisionService, icdCorporationService,
    rogersDashboardService, utilityService) {
    'ngInject';
    const vm = this;

    vm.$onInit = onInit;
    vm.endDate;
    vm.enableOnlyWeekday = enableOnlyWeekday;
    vm.icdCorporation;
    vm.icdCorporations;
    vm.onCalendarOpen = onCalendarOpen;
    vm.onRefresh = onRefresh;
    vm.onExportTsuReport = onExportTsuReport;
    vm.reportMode;
    vm.startDate;
    vm.reportType = {
        Text: "Daily",
        value: "Daily"
    };

    vm.dropdownOptions = {
        optionLabel: { Id: null, OwnerClientName: 'All Owners' },
        dataSource: new kendo.data.DataSource({
            data: vm.icdCorporations,
        }),
        headerTemplate: `
                    <div style="padding: 8px 12px; border-bottom: 1px solid \\#ddd; cursor: pointer;">
                        <label class="control control-checkbox" style="margin: 0;">
                            <input type="checkbox" id="allcorps" name="allcorps" />
                            <span class="control-indicator"></span>
                            <span>Show Active</span>
                        </label>
                    </div>
                `,
        open: () => {
            setTimeout(() => {
                const widget = $("#icd-corporation").data("kendoDropDownList");
                const source = vm.icdCorporations;
                $("#allcorps").off("click").on("click", (e) => {
                    const isChecked = $(e.target).prop("checked");

                    const filtered = isChecked
                        ? source.filter(c => c.IcdCorporationStatus === 'Active')
                        : source;
                    widget.dataSource.data(filtered);
                    widget.refresh();
                    widget.popup.open(); // keep it open after refresh
                });
            }, 0);
        }
    }

    //HACK because kendo doesn't give a way to pass variables from scope.
    // These functions will be globally available after constructing this controller
    $.setSunday = enableOnlyWeekday(0);
    $.setMonday = enableOnlyWeekday(1);

    function onInit() {

        vm.startDate = moment().subtract(1, "week").startOf("day").toDate();
        vm.endDate = moment().startOf("day").toDate();
        // Default to loading data for the 10 weeks prior to the current day.
        vm.endWeekDate = getUpcomingDayOfWeek(0); // Week endings fall on a Sunday.
        vm.startWeekDate = moment(vm.endWeekDate).add(-10, "weeks").toDate();

        vm.startDateOptions = { start: 'month', depth: 'day', disableDates: enableOnlyWeekday(1) };
        vm.endDateOptions = { start: 'month', depth: 'day', disableDates: enableOnlyWeekday(0) };

        icdCorporationService.retrieveIcdCorporationsByModuleAdmin("Payout", {
            divisionID: divisionService.divisionIDs.Rogers
        })
            .then(function (icdCorporations) {
                vm.icdCorporations = icdCorporations;
                vm.icdCorporations.forEach(formatIcdCorporation);
                vm.icdCorporations = vm.icdCorporations.sort(function (a, b) {
                    return a.OwnerClientName.toLowerCase() < b.OwnerClientName.toLowerCase() ? -1 : 1;
                });
                vm.icdCorporation = icdCorporations.filter(function (icdCorporation) {
                    return icdCorporation.Id === vm.icdCorporationID;
                })[0] || icdCorporations[0] || null;
                return vm.icdCorporation;
            });
    }

    function formatIcdCorporation(icdCorporation) {
        icdCorporation.OwnerClientName = icdCorporation.Owner + " - " + icdCorporation.ClientName;
    }

    function onExportTsuReport() {
        const query = {
            IcdCorporationID: vm.isOwnerView || !vm.icdCorporation ? null : vm.icdCorporation.Id,
            ReportType: vm.reportType.value,
            StartDate: kendo.format("{0:yyyy-MM-dd}", vm.startDate),
            EndDate: kendo.format("{0:yyyy-MM-dd}", vm.endDate),
            StartWeekDate: kendo.format("{0:yyyy-MM-dd}", vm.startWeekDate),
            EndWeekDate: kendo.format("{0:yyyy-MM-dd}", vm.endWeekDate)
        };

        const queryString = utilityService.queryStringify(query);
        const api = vm.isOwnerView ? "dashboards/rogers/owners-tsu-report.xlsx" : "dashboards/rogers/employees-tsu-report.xlsx"
        window.location = apexApiUrl + api + queryString;
    }

    function onRefresh() {
        reloadData();
    }

    function reloadData() {

        if (vm.reportType.value === "Daily") {
            if (!vm.startDate || !vm.endDate || vm.startDate > vm.endDate) {
                // Don't trigger a date reload, since the dates are required.
                return;
            }
        } else {

            if (!vm.startWeekDate || !vm.endWeekDate || vm.startWeekDate > vm.endWeekDate) {
                // Don't trigger a date reload, since the dates are required.
                return;
            }
        }
        const rogersTsuReportLoaded = loadRogersTsuReport(vm.icdCorporation);

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(rogersTsuReportLoaded, "reload failed"));
    }

    /**
     * Get the next date that falls on the given day of the week.
     * @param {Number} weekDay The day of the week, as an index starting with Sunday = 0.
     * @returns {Date} The next date that falls of the given day of the week.
     */
    function getUpcomingDayOfWeek(weekDay) {
        const currentWeekDay = new Date().getDay();
        return moment().add(weekDay < currentWeekDay ? weekDay - currentWeekDay + 7 : currentWeekDay - weekDay, "days")
            .startOf("day")
            .toDate();
    }

    function loadRogersTsuReport() {
        if (!vm.icdCorporation) {
            vm.rogersTsuReport = null;
            return $q.when();
        }

        const query = {
            IcdCorporationID: vm.isOwnerView ? null : vm.icdCorporation.Id,
            ReportType: vm.reportType.value,
            StartDate: kendo.format("{0:yyyy-MM-dd}", vm.startDate),
            EndDate: kendo.format("{0:yyyy-MM-dd}", vm.endDate),
            StartWeekDate: kendo.format("{0:yyyy-MM-dd}", vm.startWeekDate),
            EndWeekDate: kendo.format("{0:yyyy-MM-dd}", vm.endWeekDate)
        };
        const retrieveData = vm.isOwnerView ? rogersDashboardService.retrieveRogersOwnersTsuReport(query)
            : rogersDashboardService.retrieveRogersEmployeesTsuReport(query)
        return retrieveData
            .then(function (report) {
                vm.rogersTsuReport = vm.isOwnerView ? report.RogersOwnerTsuReport : report.RogersEmployeeTsuReport;
                vm.reportHeaders = report.HeaderDates;

            });
    }

    /**
     * Return a function that filters dates and only returns true if the day
     * of the week is the same as the given day of the week.
     * @param {Number} dayOfWeek
     * @returns {(date : Date) => boolean} A filter function for dates.
     */
    function enableOnlyWeekday(dayOfWeek) {
        return function (date) {
            return date.getDay() === dayOfWeek;
        };
    }

    // Workaround since the version of kendo we are using does not support disabledDates

    function setDates() {
        $(".disabledDay").parent().removeClass("k-link");//removing this class makes the day unselectable
        $(".disabledDay").parent().removeAttr("href"); //this removes the hyperlink styling
    }

    function onCalendarOpen(dp) {
        setDates();
        if (dp.sender.dateView && dp.sender.dateView.calendar) {
            const cal = dp.sender.dateView.calendar;

            if (!cal.additionalNav) {
                //var navigate = cal.navigate;
                cal.bind('navigate', function () {
                    setDates();
                });
                cal.additionalNav = true;
            }
        }

    }
}
